/**
 * @relatedFiles ./theme-color-meta.tsx, ./clerk-theme-provider.tsx, ../app/layout.tsx
 * @purpose Wrapper component for next-themes provider enabling system-wide theme management
 */
"use client";

import * as React from "react";
import { ThemeProvider as NextThemesProvider } from "next-themes";

import type { ThemeProviderProps } from "next-themes";

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return <NextThemesProvider {...props}>{children}</NextThemesProvider>;
} 